var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E0E2E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#F0F1F3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9668 18.446C24.352 18.0502 24.3434 17.4171 23.9476 17.0319C23.5519 16.6467 22.9188 16.6553 22.5335 17.0511L19.2738 20.4002L17.8756 19.2794C17.4447 18.934 16.8153 19.0033 16.4699 19.4342C16.1245 19.8651 16.1938 20.4945 16.6247 20.8399L19.0858 22.8128C19.2868 22.9739 19.5772 22.956 19.7569 22.7714L23.9668 18.446Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6095 10.3438C19.3848 9.59373 20.6153 9.59373 21.3907 10.3438L22.7194 11.6292L24.55 11.3703C25.6181 11.2192 26.6136 11.9425 26.8 13.0051L27.1194 14.826L28.7526 15.6925C29.7055 16.1981 30.0857 17.3684 29.612 18.3376L28.8001 19.9985L29.612 21.6595C30.0857 22.6287 29.7055 23.7989 28.7526 24.3046L27.1194 25.1711L26.8 26.992C26.6136 28.0546 25.6181 28.7778 24.55 28.6268L22.7194 28.3678L21.3907 29.6533C20.6153 30.4034 19.3848 30.4034 18.6095 29.6533L17.2807 28.3678L15.4502 28.6268C14.382 28.7778 13.3865 28.0546 13.2001 26.992L12.8807 25.1711L11.2476 24.3046C10.2946 23.7989 9.91438 22.6287 10.3881 21.6595L11.2001 19.9985L10.3881 18.3376C9.91438 17.3684 10.2946 16.1981 11.2476 15.6925L12.8807 14.826L13.2001 13.0051C13.3865 11.9425 14.382 11.2192 15.4502 11.3703L17.2807 11.6292L18.6095 10.3438ZM20.0001 11.7812L22.0315 13.7465L24.8301 13.3506L25.3184 16.1345L27.8152 17.4593L26.5739 19.9985L27.8152 22.5378L25.3184 23.8625L24.8301 26.6465L22.0315 26.2506L20.0001 28.2158L17.9686 26.2506L15.1701 26.6465L14.6817 23.8625L12.185 22.5378L13.4262 19.9985L12.185 17.4593L14.6817 16.1345L15.1701 13.3506L17.9686 13.7465L20.0001 11.7812Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxCode);
export default __webpack_public_path__ + "static/media/tax-code.93a062db1f6298d66d73f415bc310944.svg";
export { ForwardRef as ReactComponent };